<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('营业厅名称')" prop="businessName">
                <a-input v-model="model.businessName" :placeholder="$t('请输入营业厅名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('营业厅电话')" prop="businessPhone">
                <a-input v-model="model.businessPhone" :placeholder="$t('请输入营业厅电话')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('营业厅工作时间')" prop="businessWorkTime">
                <a-input v-model="model.businessWorkTime" :placeholder="$t('请输入营业厅工作时间')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('营业厅经度')" prop="businessLongitude">
                <a-input v-model="model.businessLongitude" :placeholder="$t('请输入营业厅经度')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('营业厅纬度')" prop="businessLatitude">
                <a-input v-model="model.businessLatitude" :placeholder="$t('请输入营业厅纬度')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('营业厅地址')" prop="businessAddress">
                <a-textarea v-model="model.businessAddress" :placeholder="$t('请输入营业厅地址')" :rows="4" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-charge/oa/oaBusinessHall/add",
          edit: "/jeecg-charge/oa/oaBusinessHall/edit",
          queryById: "/jeecg-charge/oa/oaBusinessHall/queryById",
        },
      }
    },
    computed: {
      validatorRules() {
        return {
          businessName: [{
            required: true,
            message: this.$t('请输入营业厅名称'),
            trigger: 'blur'
          }],
          businessPhone: [{
            required: true,
            message: this.$t('请输入营业厅电话'),
            trigger: 'blur'
          },{ pattern: /^0\d{2,3}-[1-9]\d{6,7}$/, message: this.$t('请输入正确的座机号码') }],
          businessWorkTime: [{
            required: true,
            message: this.$t('请输入营业厅工作日'),
            trigger: 'blur'
          }],
          businessLongitude: [{
            required: true,
            message: this.$t('请输入营业厅经度'),
            trigger: 'blur'
          }],
          businessLatitude: [{
            required: true,
            message: this.$t('请输入营业厅纬度'),
            trigger: 'blur'
          }],
          businessAddress: [{
            required: true,
            message: this.$t('请输入营业厅地址'),
            trigger: 'blur'
          }],
        }
      },
    },
    methods: {
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else if(type == 'detail'){
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }else{
          this.title = this.$t('新增');
          this.disableSubmit = false;
        }
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      }
    }
  }
</script>